import {Routes} from '@angular/router';
import {CreatePageComponent} from './create-page/create-page.component';
import {AuthGuard} from '../../../guards/auth.guard';
import {IsCompletedUserDataGuard} from '../../../guards/is-completed-user-data.guard';
import {opinionOnIssuingADecisionRoutes} from './opinion-on-issuing-a-decision/opinion-on-issuing-a-decision.routes';
import {compensationForLossesRoutes} from './compensation-for-losses/compensation-for-losses.routes';
import {placementAdvertisingRoutes} from './placement-advertising/placement-advertising.routes';
import {
  opinionOnTheProjectOfTrafficOrgRoutes
} from './opinion-on-the-project-of-traffic-org/opinion-on-the-project-of-traffic-org.routes';
import {
  approvalOfTrafficOrganizationProjectsRoutes
} from './approval-of-traffic-organization-projects/approval-of-traffic-organization-projects.routes';
import {
  localisationDevicesUnrelatedToRoadRoutes
} from './localisation-devices-unrelated-to-road/localisation-devices-unrelated-to-road.routes';
import {
  locationOfDevicesUnrelatedToRoadRoutes
} from './location-of-devices-unrelated-to-road/location-of-devices-unrelated-to-road.routes';
import {carryingOutWorksRoutes} from './carrying-out-works-application/carrying-out-works.routes';
import {
  locationReconstructionOfExitRoutes
} from './location-reconstruction-of-exit-application/location-reconstruction-of-exit.routes';
import {
  notificationOfEmergencyOccupationRoutes
} from './notification-of-emergency-occupation-application/notification-of-emergency-occupation.routes';
import {approvalOfTheExitDesignRoutes} from './approval-of-the-exit-design/approval-of-the-exit-design.routes';
import {publicInformationDisclosureRoutes} from './public-information-disclosure/public-information-disclosure.routes';
import {
  notificationGeneralRemarksRoutes
} from './notification-general-remarks-road-marking/notification-general-remarks-road-marking.routes';
import {responseToCallRoutes} from './response-to-call/response-to-call.routes';
import {documentsInformationRoutes} from './documents-information/documents-information.routes';
import {generalLetterRoutes} from './general-letter/general-letter.routes';
import {
  occupationOfLanePlacementConstructionObjectsRoutes
} from './occupation-of-lane-placement-construction-objects/occupation-of-lane-placement-construction-objects.routes';
import {withdrawalOfTheApplicationRoutes} from './withdrawal-of-the-application/withdrawal-of-the-application.routes';
import {
  cancellationOfTheApplicationRoutes
} from './cancellation-of-the-application/cancellation-of-the-application.routes';
import {complaintOfTheApplicationRoutes} from './complaint-of-the-application/complaint-of-the-application.routes';
import {permitForOversizeVehiclesRoutes} from "./permit-for-oversize-vehicles/permit-for-oversize-vehicles.routes";
import {accessToPublicRoadRoutes} from "./access-to-public-road/access-to-public-road.routes";

export const applicationCreatePageRoutes: Routes = [
  {
    component: CreatePageComponent,
    path: 'e-uslugi/odpowiedz-na-wezwanie/skladanie-wniosku',
    children: responseToCallRoutes,
    data: {
      contentUrl: 'odpowiedz-na-wezwanie'
    },
    canActivate: [AuthGuard, IsCompletedUserDataGuard]
  },
  {
    component: CreatePageComponent,
    path: 'e-uslugi/uzupelnienie-dokumentow/skladanie-wniosku',
    children: documentsInformationRoutes,
    data: {
      contentUrl: 'uzupelnienie-dokumentow'
    },
    canActivate: [AuthGuard, IsCompletedUserDataGuard]
  },
  {
    component: CreatePageComponent,
    path: 'e-uslugi/pismo-ogolne/skladanie-wniosku',
    children: generalLetterRoutes,
    data: {
      contentUrl: 'pismo-ogolne'
    },
    canActivate: [AuthGuard, IsCompletedUserDataGuard]
  },
  {
    component: CreatePageComponent,
    path: 'e-uslugi/opinia-w-sprawie-wydania-decyzji/skladanie-wniosku',
    data: {
      contentUrl: 'opinia-w-sprawie-wydania-decyzji'
    },
    children: opinionOnIssuingADecisionRoutes,
    canActivate: [AuthGuard, IsCompletedUserDataGuard]
  },
  {
    component: CreatePageComponent,
    path: 'e-uslugi/odszkodowanie-za-straty/skladanie-wniosku',
    children: compensationForLossesRoutes,
    data: {
      contentUrl: 'odszkodowanie-za-straty'
    },
    canActivate: [AuthGuard, IsCompletedUserDataGuard]
  },
  {
    component: CreatePageComponent,
    path: 'e-uslugi/umieszczenie-reklamy/skladanie-wniosku',
    children: placementAdvertisingRoutes,
    data: {
      contentUrl: 'umieszczenie-reklamy'
    },
    canActivate: [AuthGuard, IsCompletedUserDataGuard]
  },
  {
    component: CreatePageComponent,
    path: 'e-uslugi/opinia-do-projektu-organizacji-ruchu-dla-drog-publicznych/skladanie-wniosku',
    children: opinionOnTheProjectOfTrafficOrgRoutes,
    data: {
      contentUrl: 'opinia-do-projektu-organizacji-ruchu-dla-drog-publicznych'
    },
    canActivate: [AuthGuard, IsCompletedUserDataGuard]
  },
  {
    component: CreatePageComponent,
    path: 'e-uslugi/zatwierdzenie-projektow-organizacji-ruchu-dla-drog-wewnetrznych/skladanie-wniosku',
    children: approvalOfTrafficOrganizationProjectsRoutes,
    data: {
      contentUrl: 'zatwierdzenie-projektow-organizacji-ruchu-dla-drog-wewnetrznych'
    },
    canActivate: [AuthGuard, IsCompletedUserDataGuard]
  },
  {
    component: CreatePageComponent,
    path: 'e-uslugi/lokalizacja-urzadzenia-niezwiazanego-z-funkcjonowaniem-drogi/skladanie-wniosku',
    children: localisationDevicesUnrelatedToRoadRoutes,
    data: {
      contentUrl: 'lokalizacja-urzadzenia-niezwiazanego-z-funkcjonowaniem-drogi'
    },
    canActivate: [AuthGuard, IsCompletedUserDataGuard]
  },
  {
    component: CreatePageComponent,
    path: 'e-uslugi/umieszczenie-urzadzenia-niezwiazanego-z-funkcjonowaniem-drogi/skladanie-wniosku',
    children: locationOfDevicesUnrelatedToRoadRoutes,
    data: {
      contentUrl: 'umieszczenie-urzadzenia-niezwiazanego-z-funkcjonowaniem-drogi'
    },
    canActivate: [AuthGuard, IsCompletedUserDataGuard]
  },
  {
    component: CreatePageComponent,
    path: 'e-uslugi/zajecie-pasa-prowadzenie-robot/skladanie-wniosku',
    children: carryingOutWorksRoutes,
    data: {
      contentUrl: 'zajecie-pasa-prowadzenie-robot'
    },
    canActivate: [AuthGuard, IsCompletedUserDataGuard]
  },
  {
    component: CreatePageComponent,
    path: 'e-uslugi/lokalizacja-przebudowa-zjazdu/skladanie-wniosku',
    children: locationReconstructionOfExitRoutes,
    data: {
      contentUrl: 'lokalizacja-przebudowa-zjazdu'
    },
    canActivate: [AuthGuard, IsCompletedUserDataGuard]
  },
  {
    component: CreatePageComponent,
    path: 'e-uslugi/awaryjne-zajecie-pasa-drogowego/skladanie-wniosku',
    children: notificationOfEmergencyOccupationRoutes,
    data: {
      contentUrl: 'awaryjne-zajecie-pasa-drogowego'
    },
    canActivate: [AuthGuard, IsCompletedUserDataGuard]
  },
  {
    component: CreatePageComponent,
    path: 'e-uslugi/uzgodnienie-projektu-zjazdu/skladanie-wniosku',
    children: approvalOfTheExitDesignRoutes,
    data: {
      contentUrl: 'uzgodnienie-projektu-zjazdu'
    },
    canActivate: [AuthGuard, IsCompletedUserDataGuard]
  },
  {
    component: CreatePageComponent,
    path: 'e-uslugi/udostepnienie-informacji-publicznej/skladanie-wniosku',
    children: publicInformationDisclosureRoutes,
    data: {
      contentUrl: 'udostepnienie-informacji-publicznej'
    },
    canActivate: [AuthGuard, IsCompletedUserDataGuard]
  },
  {
    component: CreatePageComponent,
    path: 'e-uslugi/zgloszenie-uwagi-ogolne-oznakowanie-drog/skladanie-wniosku',
    children: notificationGeneralRemarksRoutes,
    data: {
      contentUrl: 'zgloszenie-uwagi-ogolne-oznakowanie-drog'
    },
    canActivate: [AuthGuard, IsCompletedUserDataGuard]
  },
  {
    component: CreatePageComponent,
    path: 'e-uslugi/zajecie-pasa-umieszczenie-obiektow-budowlanych/skladanie-wniosku',
    children: occupationOfLanePlacementConstructionObjectsRoutes,
    data: {
      contentUrl: 'zajecie-pasa-umieszczenie-obiektow-budowlanych'
    },
    canActivate: [AuthGuard, IsCompletedUserDataGuard]
  },
  {
    component: CreatePageComponent,
    path: 'e-uslugi/wycofanie-wniosku/skladanie-wniosku',
    children: withdrawalOfTheApplicationRoutes,
    data: {
      contentUrl: 'wycofanie-wniosku'
    },
    canActivate: [AuthGuard, IsCompletedUserDataGuard]
  },
  {
    component: CreatePageComponent,
    path: 'e-uslugi/odwolanie/skladanie-wniosku',
    children: cancellationOfTheApplicationRoutes,
    data: {
      contentUrl: 'odwolanie'
    },
    canActivate: [AuthGuard, IsCompletedUserDataGuard]
  },
  {
    component: CreatePageComponent,
    path: 'e-uslugi/zazalenie/skladanie-wniosku',
    children: complaintOfTheApplicationRoutes,
    data: {
      contentUrl: 'zazalenie'
    },
    canActivate: [AuthGuard, IsCompletedUserDataGuard]
  },
  {
    component: CreatePageComponent,
    path: 'e-uslugi/zezwolenie-przejazdy-pojazdow-nienormatywnych/skladanie-wniosku',
    children: permitForOversizeVehiclesRoutes,
    data: {
      contentUrl: 'zezwolenie-przejazdy-pojazdow-nienormatywnych'
    },
    canActivate: [AuthGuard, IsCompletedUserDataGuard]
  },
  {
    component: CreatePageComponent,
    path: 'e-uslugi/dostep-do-drogi-publicznej/skladanie-wniosku',
    children: accessToPublicRoadRoutes,
    data: {
      contentUrl: 'dostep-do-drogi-publicznej'
    },
    canActivate: [AuthGuard, IsCompletedUserDataGuard]
  }
];
